import { render } from "./ExpiryRequestList.vue?vue&type=template&id=3cd4e11a&scoped=true"
import script from "./ExpiryRequestList.vue?vue&type=script&lang=js"
export * from "./ExpiryRequestList.vue?vue&type=script&lang=js"

import "./ExpiryRequestList.vue?vue&type=style&index=0&id=3cd4e11a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd4e11a"]])

export default __exports__